/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { GenderPolicy } from 'app/shared/model/enumerations/gender-policy.model';
import { createEntity, getEntity, reset, updateEntity } from './ward.reducer';

export const WardUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const hospitals = useAppSelector(state => state.hospital.entities);
  const wardEntity = useAppSelector(state => state.ward.entity);
  const loading = useAppSelector(state => state.ward.loading);
  const updating = useAppSelector(state => state.ward.updating);
  const updateSuccess = useAppSelector(state => state.ward.updateSuccess);
  const genderPolicyValues = Object.keys(GenderPolicy);

  const handleClose = () => {
    navigate(`/ward${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getHospitals({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.dateClosed !== undefined && typeof values.dateClosed !== 'number') {
      values.dateClosed = Number(values.dateClosed);
    }
    if (values.roomNoStart !== undefined && typeof values.roomNoStart !== 'number') {
      values.roomNoStart = Number(values.roomNoStart);
    }
    if (values.roomNoEnd !== undefined && typeof values.roomNoEnd !== 'number') {
      values.roomNoEnd = Number(values.roomNoEnd);
    }
    if (values.modifiedTime !== undefined && typeof values.modifiedTime !== 'number') {
      values.modifiedTime = Number(values.modifiedTime);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...wardEntity,
      ...values,
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          genderPolicy: 'MALEONLY',
          ...wardEntity,
          hospital: wardEntity?.hospital?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.ward.home.createOrEditLabel" data-cy="WardCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.ward.home.createOrEditLabel">Create or edit a Ward</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="ward-id"
                  label={translate('tinyMedicRestApp.ward.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField label={translate('tinyMedicRestApp.ward.name')} id="ward-name" name="name" data-cy="name" type="text" />
              <ValidatedField
                label={translate('tinyMedicRestApp.ward.tempClosed')}
                id="ward-tempClosed"
                name="tempClosed"
                data-cy="tempClosed"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.ward.dateClosed')}
                id="ward-dateClosed"
                name="dateClosed"
                data-cy="dateClosed"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.ward.description')}
                id="ward-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <ValidatedField label={translate('tinyMedicRestApp.ward.info')} id="ward-info" name="info" data-cy="info" type="text" />
              <ValidatedField
                label={translate('tinyMedicRestApp.ward.roomNoStart')}
                id="ward-roomNoStart"
                name="roomNoStart"
                data-cy="roomNoStart"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.ward.roomNoEnd')}
                id="ward-roomNoEnd"
                name="roomNoEnd"
                data-cy="roomNoEnd"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.ward.roomPrefix')}
                id="ward-roomPrefix"
                name="roomPrefix"
                data-cy="roomPrefix"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.ward.modifiedBy')}
                id="ward-modifiedBy"
                name="modifiedBy"
                data-cy="modifiedBy"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.ward.modifiedTime')}
                id="ward-modifiedTime"
                name="modifiedTime"
                data-cy="modifiedTime"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.ward.createdBy')}
                id="ward-createdBy"
                name="createdBy"
                data-cy="createdBy"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.ward.microSec')}
                id="ward-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.ward.timestampentry')}
                id="ward-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.ward.lastupdated')}
                id="ward-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.ward.cursor')}
                id="ward-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.ward.active')}
                id="ward-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.ward.genderPolicy')}
                id="ward-genderPolicy"
                name="genderPolicy"
                data-cy="genderPolicy"
                type="select"
              >
                {genderPolicyValues.map(genderPolicy => (
                  <option value={genderPolicy} key={genderPolicy}>
                    {translate(`tinyMedicRestApp.GenderPolicy.${genderPolicy}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="ward-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.ward.hospital')}
                type="select"
                required
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/ward" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default WardUpdate;
